import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import './index.scss';

const Politica = () => {
  return (
    <div className="politica-container">
      <Header variant="dark" />
      <div className="content">
        <p className="title-one">POLÍTICA DE PRIVACIDAD – PITAGE</p>

        <p>
          La presente Política de Privacidad tiene como finalidad informar de manera clara, transparente y suficiente cómo Pitage (en adelante, “la Empresa”, “nosotros” o “Pitage”) recopila, utiliza, almacena, protege y trata los datos personales y demás información relacionada de los usuarios que acceden o utilizan nuestras aplicaciones móviles y sitios web (conjuntamente, la “Plataforma”).
        </p>
        <p>
          Pitage respeta el derecho a la privacidad de los usuarios y se compromete a tratar sus datos personales de conformidad con la presente Política de Privacidad y con la normativa vigente en materia de protección de datos personales aplicable en la República Argentina.
        </p>

        <p className="title-two">Finalidades del Tratamiento de Datos</p>
        <p>
          La Empresa recopila y trata datos personales de manera lícita, proporcional y necesaria, exclusivamente para las siguientes finalidades:
        </p>
        <p className="bullet">Verificación de identidad y autenticación de usuarios, así como la prevención de accesos o usos no autorizados.</p>
        <p className="bullet">Gestión de riesgos y prevención de fraudes, incluyendo la detección y análisis de conductas irregulares.</p>
        <p className="bullet">Evaluación crediticia y análisis de solicitudes de préstamo, determinando la elegibilidad y condiciones de los productos financieros.</p>
        <p className="bullet">Comunicación con el usuario, para notificaciones relacionadas con solicitudes, operaciones, seguridad o atención al cliente.</p>
        <p className="bullet">Cumplimiento de obligaciones legales y regulatorias aplicables.</p>
        <p className="bullet">Protección y seguridad del sistema, garantizando la estabilidad e integridad de la Plataforma.</p>

        <p className="title-two">Tipos de Información Recopilada y Permisos Solicitados</p>

        <p className="title-three">1. Verificación de Identidad y Uso de la Cámara</p>
        <p>
          Para fines de identificación y control antifraude, Pitage podrá solicitar acceso a la cámara del dispositivo con el objeto de capturar imágenes de documentos de identidad y realizar validaciones biométricas.
        </p>
        <p>
          Las imágenes obtenidas se utilizarán exclusivamente para la verificación de identidad y serán transmitidas y almacenadas de forma cifrada en los servidores designados (<span className="highlight">https://prd.pitagepe.com</span>), únicamente para uso interno.
        </p>

        <p className="title-three">2. Acceso a la Galería (solo fotografías seleccionadas)</p>
        <p>
          Durante el proceso de solicitud de préstamo, Pitage podrá solicitar acceso a la galería del dispositivo, limitado únicamente a las imágenes que el usuario seleccione y cargue voluntariamente.
        </p>
        <p>
          Las imágenes se transmitirán mediante canales seguros y cifrados y se almacenarán en los servidores (<span className="highlight">https://prd.pitagepe.com</span>) por un período máximo de un (1) año.
        </p>
        <p>
          El usuario podrá solicitar su eliminación contactando al servicio de atención al cliente, la cual se efectuará dentro de un plazo de tres (3) a cinco (5) días hábiles.
        </p>

        <p className="title-three">3. Información Personal Básica</p>
        <p>
          Para la creación y gestión de la cuenta, así como para la evaluación crediticia, Pitage podrá recopilar datos personales básicos, tales como nombre, número de teléfono y tipo de cuenta.
        </p>
        <p>
          Dicha información será almacenada de manera cifrada en los servidores (<span className="highlight">https://prd.pitagepe.com</span>) y utilizada exclusivamente para fines internos. No será compartida con terceros sin el consentimiento expreso del usuario, salvo obligación legal.
        </p>

        <p className="title-three">4. Información del Dispositivo</p>
        <p>
          Con el fin de reforzar la seguridad de la cuenta y optimizar los procesos de evaluación de riesgos, Pitage podrá recopilar información básica del dispositivo, como modelo, idioma del sistema y un identificador único del dispositivo.
        </p>
        <p>
          Esta información se almacenará de forma cifrada en los servidores (<span className="highlight">https://prd.pitagepe.com</span>) y no será compartida con terceros, salvo requerimiento legal.
        </p>

        <p className="title-three">5. Ubicación Geográfica Aproximada</p>
        <p>
          Con fines exclusivos de seguridad y control de riesgos, Pitage podrá obtener información de ubicación aproximada del dispositivo y transmitirla a los servidores designados (<span className="highlight">https://prd.pitagepe.com</span>).
        </p>
        <p>
          El servicio se encuentra disponible únicamente para usuarios ubicados dentro del territorio de la República Argentina.
        </p>
        <p>
          En ningún caso esta información será compartida con terceros sin el consentimiento expreso del usuario.
        </p>

        <p className="title-three">6. Contactos de Emergencia：</p>
        <p>Con fines de gestión de riesgos, el usuario podrá proporcionar hasta dos (2) contactos de emergencia de forma voluntaria.\nPitage no accede a la agenda completa del dispositivo, sino únicamente a la información que el usuario autorice expresamente.\nEstos datos se almacenarán de forma cifrada en los servidores (https://prd.pitagepe.com) y se utilizarán únicamente cuando resulte estrictamente necesario.</p>

        <p className="title-three">7. Socios Tecnológicos y Terceros</p>
        <p>
          Pitage podrá colaborar con proveedores de servicios tecnológicos mediante el uso de SDK y Deeplinks, con el fin de analizar el origen del tráfico de usuarios desde canales como Google y Facebook.
        </p>
        <p>
          Ni los Deeplinks ni la aplicación acceden, recopilan o utilizan el contenido de las cuentas personales de redes sociales del usuario.
        </p>

        <p className="title-two">Compromiso de Protección de la Privacidad</p>
        <p>
          La información recopilada será tratada exclusivamente para la prestación de los servicios de Pitage. La Empresa no vende ni divulga datos personales a terceros sin el consentimiento del usuario, salvo en los casos exigidos por ley o por autoridad competente.
        </p>

        <p className="title-two">Medidas de Seguridad</p>
        <p>
          Pitage adopta medidas físicas, técnicas y administrativas razonables para proteger los datos personales, incluyendo:
        </p>
        <p className="bullet">Cifrado durante la transmisión y el almacenamiento de la información.</p>
        <p className="bullet">Controles estrictos de acceso interno y deberes de confidencialidad.</p>
        <p className="bullet">Revisión periódica de los procesos de tratamiento de datos.</p>
        <p className="bullet">Actualización continua conforme a la normativa aplicable.</p>

        <p className="title-two">Protección de Menores</p>
        <p>
          La Plataforma está destinada exclusivamente a personas mayores de dieciocho (18) años.
        </p>
        <p>
          Los menores de edad no deben utilizar los servicios de Pitage.
        </p>

        <p className="title-two">Derechos del Usuario sobre sus Datos Personales (ARCO)</p>
        <p>
          De conformidad con la legislación vigente en materia de protección de datos personales, el usuario tiene derecho a ejercer en cualquier momento los siguientes derechos respecto de sus datos personales tratados por Pitage:
        </p>

        <p className="title-three">1. Acceso</p>
        <p>
          El usuario tiene derecho a solicitar información sobre si Pitage trata o no sus datos personales. En caso afirmativo, podrá acceder a dichos datos y conocer, entre otros aspectos, el origen de la información, las finalidades del tratamiento y las categorías de datos tratados.
        </p>

        <p className="title-three">2. Rectificación</p>
        <p>
          El usuario podrá solicitar la corrección, actualización o complementación de sus datos personales cuando estos resulten inexactos, incompletos o desactualizados, a fin de garantizar que la información tratada por Pitage sea correcta y vigente.
        </p>

        <p className="title-three">3. Cancelación</p>
        <p>
          El usuario tiene derecho a solicitar la eliminación de sus datos personales cuando considere que los mismos ya no son necesarios para las finalidades para las cuales fueron recopilados o cuando su tratamiento no se ajuste a la normativa aplicable.
        </p>
        <p>
          Este derecho se ejercerá sin perjuicio de las obligaciones legales de conservación que correspondan.
        </p>

        <p className="title-three">4. Oposición</p>
        <p>
          El usuario podrá oponerse al tratamiento de sus datos personales por motivos legítimos, en los casos y bajo las condiciones previstas por la legislación vigente. Pitage evaluará la solicitud y, de corresponder, cesará el tratamiento de los datos objeto de oposición.
        </p>

        <p className="title-three">5. Revocación del Consentimiento</p>
        <p>
          Cuando el tratamiento de datos personales se base en el consentimiento del usuario, este podrá revocarlo en cualquier momento, sin efectos retroactivos. La revocación no afectará la licitud del tratamiento realizado con anterioridad.
        </p>

        <p className="title-three">6. Cancelación de la Cuenta</p>
        <p>
          El usuario podrá solicitar la suspensión o cancelación definitiva de su cuenta en la Plataforma. Una vez cancelada la cuenta, Pitage procederá al tratamiento y, en su caso, a la eliminación de los datos personales conforme a la legislación vigente y a los plazos legales de conservación aplicables.
        </p>

        <p className="title-two">Ejercicio de Derechos</p>
        <p>
          Para ejercer cualquiera de los derechos mencionados, el usuario podrá contactar al servicio de atención al cliente de Pitage a través de los canales oficiales indicados en la presente Política de Privacidad.
        </p>
        <p>
          Pitage analizará y responderá la solicitud dentro de los plazos establecidos por la normativa aplicable.
        </p>

        <p className="title-two">Cancelación de la Cuenta</p>
        <p>
          El usuario podrá solicitar la cancelación de su cuenta a través de la aplicación, del sitio web oficial o mediante correo electrónico al canal de atención indicado. Pitage procesará la solicitud conforme a la normativa aplicable.
        </p>

        <p className="title-two">Actualizaciones de la Política</p>
        <p>
          Pitage podrá modificar la presente Política de Privacidad cuando resulte necesario. Las modificaciones entrarán en vigor desde su publicación.
        </p>

        <p className="title-two">Aceptación del Usuario</p>
        <p>
          Al acceder, registrarse o utilizar la Plataforma de Pitage, el usuario declara haber leído, comprendido y aceptado íntegramente esta Política de Privacidad.
        </p>

        <p className="title-two">Contacto de Privacidad</p>
        <p>
          Para consultas relacionadas con esta Política o con el tratamiento de datos personales, el usuario podrá contactar a Pitage a través del siguiente correo electrónico:
        </p>
        <p>
          Correo electrónico oficial: <span className="highlight">informacion.pitage@gmail.com</span>
        </p>
      </div>
      <Footer />
    </div>
  )
}

export default Politica;
